import Helpers from '@Apis/helpers';
import Constants from '@Apis/constants';

/**
 * @param tenantId
 * @param invoiceId
 * @param poId
 */
class InvoiceServices {
  /**
   *
   * @param {*} payload
   * @return
   */
  createInvoice = async (payload) => {
    const invoice = await Helpers.post({
      url: Constants.Invoice,
      data: payload,
    });
    return invoice;
  }

  /**
   *
   * @param {*} payload
   * @return
   */
  updateInvoice = async (payload) => {
    const invoice = await Helpers.put({
      url: Constants.Invoice,
      data: payload,
    });
    return invoice;
  }

  quickUpdateInvoice = async (payload) => {
    const invoice = await Helpers.put({
      url: Constants.INVOICE_QUICK_UPDATE,
      data: payload,
    });
    return invoice;
  }

  /**
   *
   * @param {*} payload
   * @return
   */
  updateInvoiceStatus = async (payload) => {
    const po = await Helpers.put({
      url: Constants.Invoice_STATUS,
      data: payload,
    });
    return po;
  }

  /**
   * @param {*} orgId
   * @param {*} entityType
   * @param {*} invoiceId
   * @param {*} page
   * @param tenantId
   * @param customerId
   * @param searchKeyword
   * @param {*} limit
   * @return
   */
  getInvoice = async (orgId, tenantId, invoiceId, page, limit, customerId, searchKeyword, status, startDate, endDate, departmentId, listScreen, paymentStatus, isEwayBilled, secondaryStatus, shopifySearchKeyword, tags, isMarketplaceInvoice, accountManagerIds, source, stockStatus, excludeInvoiceIds, excludeGRNCustomerIds, invoiceType) => {
    let url = `${Constants.Invoice}?`;
    if (orgId) url += `org_id=${orgId}&`;
    if (tenantId) url += `tenant_ids=${tenantId}&`;
    if (searchKeyword) url += `search_keyword=${searchKeyword}&`;
    if (invoiceId) url += `invoice_id=${invoiceId}&`;
    if (limit) url += `limit=${limit}&`;
    if (page) url += `page=${page}&`;
    if (customerId) url += `customer_id=${customerId}&`;
    if (excludeGRNCustomerIds) url += `customer_ids=${excludeGRNCustomerIds}&`;
    if (status) url += `status=${status}&`;
    if (paymentStatus) url += `payment_status=${paymentStatus}&`;
    if (startDate) url += `from_date=${startDate}&`;
    if (endDate) url += `to_date=${endDate}&`;
    if (departmentId) url += `department_id=${departmentId}&`;
    if (listScreen) url += `list_screen=${listScreen}&`;
    if (isEwayBilled) url += `is_e_way_billed=${isEwayBilled}&`;
    if (secondaryStatus) url += `secondary_status=${secondaryStatus}&`;
    if (shopifySearchKeyword) url += `shopify_search_keyword=${shopifySearchKeyword}&`;
    if (tags) url += `tags=${tags}&`;
    if (isMarketplaceInvoice) url += `is_marketplace_invoice=${isMarketplaceInvoice}&`;
    if (accountManagerIds) url += `account_manager_ids=${accountManagerIds}&`;
    if (source) url += `source=${source}&`;
    if (excludeInvoiceIds) url += `exclude_invoice_ids=${excludeInvoiceIds}&`;
    if (stockStatus) url += `stock_status=${stockStatus}&`;
    if(invoiceType) url += `invoice_type=${invoiceType}&`;
    const invoice = await Helpers.get({ url });
    return invoice;
  }

  /**
   *
   * @param {*} payload
   * @return
   */
  updateInvoiceWorkflowStep = async (payload) => {
    const po = await Helpers.post({
      url: Constants.Invoice_WORKFLOW,
      data: payload,
    });
    return po;
  }

  /**
   *
   * @param {*} payload
   * @return
   */
  LinkInvoicePayments = async (payload) => {
    const po = await Helpers.post({
      url: Constants.INVOICE_LINK_PAYMENT,
      data: payload,
    });
    return po;
  }

  /**
   *
   * @param {*} payload
   * @return
   */

  UnlinkInvoicePayments = async (invoicePaymentId) => {
    const linkPayment = await Helpers.delete({
      url: `${Constants.INVOICE_UNLINK_PAYMENT}${invoicePaymentId ? `?invoice_payment_id=${invoicePaymentId}` : ''}`,
    });
    return linkPayment;
  }

  /**
   *
   * @param {*} payload
   * @return
   */
  deleteInvoice = async (payload) => {
    const po = await Helpers.delete({
      url: Constants.Invoice,
      data: payload,
    });
    return po;
  }

  downloadInvoices = async (invoiceIds, fileType, sortBy) => {
    let url = `${Constants.Invoice}/download?`;
    if (invoiceIds) url += `invoice_ids=${invoiceIds}&`;
    if (fileType) url += `type=${fileType}&`;
    if (sortBy) url += `order_by=${sortBy}&`;
    const response = await Helpers.getFile({
      url,
    });
    return response;
  }

  downloadShippingLabels = async (invoiceIds, fileType, withPrice) => {
    let url = `${Constants.DOWNLOAD_SHIPPING_LABELS}/download?`;
    if (invoiceIds) url += `invoice_ids=${invoiceIds}&`;
    if (fileType) url += `type=${fileType}&`;
    if (withPrice) url += `with_price=${withPrice}&`;
    const shippingLabel = await Helpers.getFile({ url });
    return shippingLabel;
  }
  // Download Invoice List

  downloadInvoiceList = async (payload) => {
    const list = await Helpers.post({
      url: Constants.DOWNLOAD_INVOICE_LIST,
      data: payload,
    });
    return list;
  }

  /**
   *
   * @param payload
   * @returns {Promise<*>}
   */
  createBulkReturns = async (payload) => {
    const url = Constants.CREATE_BULK_RETURNS;
    const data = new FormData();
    data.append('sheet', payload?.file);
    const bulkUpload = await Helpers.filePost({
      url,
      file: data,
    });
    return bulkUpload;
  }

  // issue Stock for invoice
  issueStockForInvoice = async (payload) => {
    const po = await Helpers.post({
      url: `${Constants.Invoice}/issue_adjustment`,
      data: payload,
    });
    return po;
  }

  // cancel Stock for invoice
  revertStockForInvoice = async (payload) => {
    const po = await Helpers.post({
      url: `${Constants.Invoice}/cancel_adjustment`,
      data: payload,
    });
    return po;
  }
}
export default new InvoiceServices();
